import styled from 'styled-components';

import Button from 'components/shared/Button';
import ButtonGroup from 'components/shared/ButtonGroup';
import StandardModal, { ColorThemeName } from 'components/shared/StandardModal';
import { BodySmall } from 'styles/typography';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
};

export default function CategoryDeleteModal({ onConfirm, onCancel }: Props) {
  return (
    <StandardModal title='Delete Category' onCancel={onCancel} colorTheme={ColorThemeName.PrimaryRed}>
      <Content>
        <BodySmall>
          <strong>Are you sure you wish to delete this category?</strong> All criteria applied to this category will be
          lost.
        </BodySmall>
        <Buttons>
          <Button variant='ghost' onClick={onCancel}>
            Cancel
          </Button>
          <Button variant='danger' onClick={onConfirm}>
            Delete Category
          </Button>
        </Buttons>
      </Content>
    </StandardModal>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Buttons = styled(ButtonGroup)`
  justify-content: flex-end;
`;
